<template>
      <div>
            <!-- Submenu -->
            <client-submenu/>

            <!-- Content -->
            <core-layout-content medium>
                  <core-layout-headline-and-actions>
                        <template slot="headline">{{ $t("objects") }}</template>
                        <!-- Display this only if it's in tenants settings -->
                        <template slot="actions">
                              <j-button type="primary" @click="$modal.show('addObject')">
                                    <crm-icon name="add" size="small" color="c5"/>
                                    {{ $t("add") }}
                              </j-button>
                        </template>
                  </core-layout-headline-and-actions>

                  <core-entity-card
                        v-for="(item,i) in clientsObjects"
                        class="mb2"
                        :key="i"
                        :entity="item"
                        :pinnable="false"
                        :hasActions="true"
                        :isExpanded="false"
                        @added="fetchclientsObjects"
                        @updated="fetchclientsObjects"
                        @deleted="fetchclientsObjects"
                  >
                        <!-- Delete -->
                        <!-- <div slot="footer" class="bt1 bc7 mt6 pt2 flex xs-12 xs-right">
                              <j-button
                                    type="error"
                                    size="small"
                                    @click="handleDelete(item.id)"
                              >{{$t("delete")}}</j-button>
                        </div>-->
                  </core-entity-card>

                  <!-- If no data -->
                  <j-card class="bg5 ta2 fs3 p2" v-if="clientsObjects.length === 0">{{ $t("errors.no_data") }}</j-card>

                  <!-- Add Modal -->
                  <core-modal name="addObject" :headline="$t('add_object')">
                        <div class="p4">
                              <core-form-input
                                    componentName="j-base-input-text"
                                    name="name"
                                    :label="$t('name')"
                                    v-validate="'required'"
                                    v-model="form.name"
                                    :validationErrors="errors"
                                    class="mb2"
                              />
                              <j-button @click="handleAdd">{{ $t("add") }}</j-button>
                        </div>
                  </core-modal>
            </core-layout-content>
      </div>
</template>

<script>
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions"
import CoreModal from "@/modules/core/components/CoreModal"
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import CoreEntityCard from "@/modules/core/components/CoreEntityCard/"
import CrmIcon from "@/components/CrmIcon/"
import JButton from "@/components/JButton/"
import JCard from "@/components/JCard/"
import JList from "@/components/JList/"
import ClientSubmenu from "../components/ClientSubmenu"
import dayjs from "dayjs"
import api from "@/modules/clients/api/"

export default {
	components: {
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		CoreModal,
		CoreFormInput,
		CoreEntityCard,
		CrmIcon,
		ClientSubmenu,
		JButton,
		JCard,
		JList
	},

	data() {
		return {
			clientsObjects: [],
			form: {
				name: null
			}
		}
	},

	methods: {
		async fetchclientsObjects() {
			let apiKeys = null

			if (this.$route.params.clientType === "individual")
				apiKeys = {
					request: "individualObjects",
					result: "individuals"
				}
			else
				apiKeys = {
					request: "companyObjects",
					result: "companies"
				}

			let where = { id: this.$route.params.id }
			const res = await api[apiKeys.request]({ where })

			// Error
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
			}

			this.clientsObjects = res.data[
				apiKeys.result
			].list[0].relationships.map(item => item.entity)
		},

		async handleAdd() {
			let createObjectInput = { nameFormat: this.form.name }

			// create object
			const res1 = await api.createObject({ createObjectInput })

			// Error
			if (res1.errors) {
				this.$store.dispatch("showError", res1.errors)
			}

			let targetId = res1.data.createObject.createdStatus.id

			let linkInput = {
				sourceId: this.$route.params.id,
				targetId,
				link: "owns"
			}

			// addlink
			const res2 = await api.addLink({ linkInput })
			if (res2.errors) {
				this.$store.dispatch("showError", res2.errors)
			}

			this.$modal.hide("addObject")

			// refetch clientsObjects
			this.fetchclientsObjects()
		}

		// async handleDelete(id) {
		// 	const res = await api.deleteCustomer({ id })

		// 	// Error
		// 	if (res.errors) {
		// 		this.$store.dispatch("showError", res.errors)
		// 	}
		// }
	},

	mounted() {
		this.fetchclientsObjects()
	}
}
</script>
